module.exports = __webpack_public_path__ + "static/media/back.8ced981e.svg";